
import { createSlice } from '@reduxjs/toolkit';
import { fetcherGet, fetcherPost } from "../utils/fetcher";
import { APIS, isEmpty, MeetingType } from "../utils/constants";
import { setLoader } from './commonSlice';
import { setOpenPopup, setOpenPopupReport } from './documentSlice';

const initialState = {
    preBookMentorDetails: [],
    upcomingMeetings: [],
    previousMeetings: [],
    cancelledgMeetings: [],
    rescheduledMeetings: [],
    scheduledMeetingsResponse: [],
    meetingCanceled: false,
    meetingComments: [],
    availableSlots: [],
    pendingMeetingFeedback: []
}

const calendlySlice = createSlice({
    name: 'calendly',
    initialState,
    reducers: {
        setMentorDetails: (state, action) => {
            state.preBookMentorDetails = action.payload;
        },
        setUpcomingMeetings: (state, action) => {
            state.upcomingMeetings = action.payload;
        },
        setPreviousMeetings: (state, action) => {
            state.previousMeetings = action.payload;
        },
        setCancelledMeetings: (state, action) => {
            state.cancelledgMeetings = action.payload;
        },
        setRescheduledMeetings: (state, action) => {
            state.rescheduledMeetings = action.payload;
        },
        setScheduledMeetingsResponse: (state, action) => {
            state.scheduledMeetingsResponse = action.payload
        },
        setMeetingComments: (state, action) => {
            state.meetingComments = action.payload
        },
        setAvailableSlots: (state, action) => {
            state.availableSlots = action.payload
        },
        setPendingMeetingFeedback: (state, action) => {
            state.pendingMeetingFeedback = action.payload
        }
    }
});

export function getPreBookMentorDetails(userId, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.MENTOR_BIO_DETAILS + userId)
            .then((res) => {
                dispatch(setMentorDetails(res?.data));
                dispatch(setLoader(false));
                if(callback){
                callback(res)
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err)
                    }
                dispatch(setLoader(false));
            });
    };
}

export function getScheduledMeeting(type = "", userId = "", flag = "") {
    return (dispatch) => {
        dispatch(setLoader(true));

        let url = APIS.GET_SCHEDULED_MEETINGS;
        if (!isEmpty(type)) {
            url += `?type=${type}`;
        }
        if (!isEmpty(userId)) {
            url += `${url.includes('?') ? '&' : '?'}userId=${userId}`;
        }
        if (!isEmpty(flag)) {
            url += `${url.includes('?') ? '&' : '?'}flag=${flag}`;
        }
        url += `${url.includes('?') ? '&' : '?'}limit=100`;

        fetcherGet(url)
            .then((res) => {
                if (flag === MeetingType.upcoming) {
                    dispatch(setUpcomingMeetings(res?.data?.result));
                }
                if (flag === MeetingType.previous) {
                    dispatch(setPreviousMeetings(res?.data?.result));
                }
                if (flag === MeetingType.cancelled) {
                    dispatch(setCancelledMeetings(res?.data?.result));
                }
                if (flag === MeetingType.rescheduled) {
                    dispatch(setRescheduledMeetings(res?.data?.result));
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function scheduleMeeting(payload, specificUserId = "", callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.SCHEDULE_MEETING, payload)
            .then((res) => {
                dispatch(setScheduledMeetingsResponse(res?.data?.data));
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.upcoming));
                dispatch(setLoader(false));
                if(callback){
                    callback(res)
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err);
                }
                dispatch(setLoader(false));
            });
    };
}

export function scheduledMeetingMessage(payload, specificUserId = "") {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.SCHEDULED_MEETING_MESSAGE, payload)
            .then(() => {
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.upcoming));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function cancelMeeting(payload, callback, specificUserId = "", cancelFailureCallback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.CANCEL_MEETING, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.upcoming));
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.cancelled));
                if (callback && typeof callback === 'function') {
                    callback(true);
                }
            })
            .catch((err) => {
                dispatch(setLoader(false));
                if (callback && typeof callback === 'function') {
                    callback(false);
                }
                if(cancelFailureCallback){
                    cancelFailureCallback(err)
                }
            });
    };
}

export function rescheduleMeeting(payload, callback, specificUserId = "", callbackResponse) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.RESCHEDULE_MEETING, payload)
            .then((res) => {
                dispatch(setLoader(false));
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.upcoming));
                dispatch(getScheduledMeeting("", specificUserId, MeetingType.rescheduled));
                //showing success popup only when succesfull
                if (callback && typeof callback === 'function' && res?.messageKey=="SUCCESS") {
                    callback(true);
                }
                if(callbackResponse){
                    callbackResponse(res)
                }
            })
            .catch((err) => {
                if(callbackResponse){
                    callbackResponse(err)
                }
                dispatch(setLoader(false));
            });
    };
}

export function scheduledMeetingFeedback(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.MEETING_FEEDBACK, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(setOpenPopup(true))
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function feedbackReport(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.FEEDBACK_REPORT, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(setOpenPopupReport(true))
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getMeetingComments(meetingId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GET_MEETING_COMMENT + meetingId)
            .then((res) => {
                dispatch(setMeetingComments(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getCalToken(params, callBack) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        let URL = APIS.REFRESH_TOKEN;
        if (params) {
            URL = APIS.REFRESH_TOKEN + params;
        }
        fetcherGet(URL)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data?.accessToken);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function checkMeetingCredits(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.CHECK_MEETING_CREDITS, payload)
            .then((res) => {
                if (callback && typeof callback === 'function') {
                    callback(res);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getCalInfo(userId = false, callback) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        let URL = APIS.GET_CAL_INFO;
        if (userId) {
            URL = `${APIS.GET_CAL_INFO}?user_id=${userId}`
        }
        fetcherGet(URL)
            .then((res) => {
                if (callback && typeof callback === 'function') {
                    callback(res?.data);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getAvailableSlots(params, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GETS_LOTS + params)
            .then((res) => {
                if (!isEmpty(res?.data?.slots)) {
                    dispatch(setAvailableSlots(res));
                }
                if (callback) {
                    callback(res)
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                if (callback) {
                    callback(err)
                }
                dispatch(setLoader(false));
            });
    };
}

export function checkUsersMeetingFeedback() {
    return (dispatch) => {
        fetcherGet(APIS.CHECK_USERS_FEEDBACK)
            .then((res) => {
                dispatch(setPendingMeetingFeedback(res?.data || []));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export const { setMentorDetails, setUpcomingMeetings, setPreviousMeetings, setAvailableSlots,
    setScheduledMeetingsResponse, setRescheduledMeetings, setCancelledMeetings, setMeetingComments, setPendingMeetingFeedback } = calendlySlice.actions;
export default calendlySlice.reducer;